<template>
  <BaseModal :open="open" @update:open="updateOpen" dialog-classes="w-screen max-w-xl">
    <div class="rounded-md bg-white px-4 py-6 lg:px-6">
      <p class="mb-4 text-2xl font-bold text-slate-900">Edit Entry</p>
      <FormInput placeholder="Title" :model-value="certificate.title"
                 @update:model-value="updateCertificate('title', $event)"/>
      <FormDragFile
        :placeholder="candidateEducationBadges.licenses.allows.file"
        :file="certificate?.file"
        :path="certificate?.path"
        @update:file="updateCertificate('file', $event)"
        @update:path="updateCertificate('path', $event)"
        :accept="candidateEducationBadges.licenses.mimes"
        class="my-6"/>
      <FormButton @click="updateOpen(false)" color="green" class="mx-auto mt-6 block max-w-fit">
        Done
      </FormButton>
    </div>
  </BaseModal>
</template>

<script setup>
import BaseModal from "./BaseModal.vue";
import FormInput from "./FormInput.vue";
import FormDragFile from "./FormDragFile.vue";
import FormButton from "./FormButton.vue";
import {candidateEducationBadges} from "../helpers/ProfileQuestions.js";

const emits = defineEmits(["update:open", "update:certificate"]);
const props = defineProps({
  open: Boolean,
  certificate: Object,
});

const updateCertificate = (key, value) => {
  const c = {...props.certificate};
  c[key] = value;
  emits("update:certificate", c);
};

const updateOpen = (value) => emits("update:open", value);
</script>
